import React from 'react';
import CodeField from '../../components/Textfields/CodeField';
import BackButton from '../../components/Buttons/BackButton';
import ExternalTemplate from '../../components/Templates/ExternalTemplate';
import Text from '../../components/Typography/Text';
import Button from '../../components/Buttons/Button';
import LinkButton from '../../components/Buttons/LinkButton';
import FormMessage from '../../components/Messages/FormMessage';
import { loginWeb, validateAuthCode } from '../../services/AuthService';

const LoginAuthCode = ({
  history,
  location: {
    state: { authenticationMode, email, password, sessionKey, correspondent },
  },
}) => {
  const [authCode, setAuthCode] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState({
    type: '',
    value: '',
  });

  const handleSubmitCode = async (e) => {
    e.preventDefault();
    setMessage({ type: '', value: '' });

    if (authCode === '') {
      setMessage({ type: 'error', value: 'Verfication code is required.' });
      return;
    }
    setLoading(true);
    try {
      await validateAuthCode({
        password,
        email,
        authCode,
        authenticationMode,
        sessionKey,
        correspondent,
      });

      window.location = '/';
    } catch (error) {
      if (error.message) {
        setMessage({ type: 'error', value: error.message });
        setLoading(false);
        return;
      }
    }
  };

  const handleResendCode = async () => {
    const resetTimer = document.getElementById('timerReset');
    await loginWeb({ authenticationMode, email, password });
    resetTimer.click();
  };

  return (
    <ExternalTemplate>
      <form autoComplete="off" onSubmit={handleSubmitCode}>
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mb={40} variant="h2" label="Authentication" />
          </div>
          <div className="grd-cell-none">
            <BackButton
              onClick={() => {
                history.push('/login');
              }}
            />
          </div>
        </div>
        {message.value && <FormMessage type={message.type} message={message.value} />}
        <CodeField
          autoFocus={true}
          max={6}
          showIcon={true}
          startTimer={authenticationMode !== 'Authenticator'}
          setLoading={setLoading}
          name="code"
          label="Authentication Code"
          placeholder="6 Alphanumeric Code"
          type="text"
          value={authCode}
          onChange={(e) => {
            setAuthCode(e.target.value);
          }}
        />
        <Button
          mt={true}
          disabled={loading.sendCode}
          loading={loading.sendCode}
          label={loading.sendCode ? 'Submitting...' : 'Submit Code'}
          onClick={handleSubmitCode}
        />
        {authenticationMode !== 'Authenticator' && (
          <div className="grd-row auth-acc">
            <div className="grd-cell-none">
              <Text variant="subtitle1" label="Didn't receive your code?" />
            </div>
            <div className="grd-cell">
              <LinkButton
                tooltipTitle="New code will not be generated and send until the code expired"
                type="button"
                label="Resend code."
                onClick={handleResendCode}
              />
            </div>
          </div>
        )}
      </form>
    </ExternalTemplate>
  );
};

export default LoginAuthCode;
